import { render } from "./saleStock.vue?vue&type=template&id=37ba3dc3&scoped=true"
import script from "./saleStock.vue?vue&type=script&lang=js"
export * from "./saleStock.vue?vue&type=script&lang=js"

import "./saleStock.vue?vue&type=style&index=0&id=37ba3dc3&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ba3dc3"]])

export default __exports__